import { Controller } from "@hotwired/stimulus"

// One checkbox that ticks or clears a group of others, and follows them.
//
//   <fieldset data-controller="check-all">
//     <input type="checkbox" data-check-all-target="all" data-action="check-all#toggle">
//     <input type="checkbox" data-check-all-target="item" data-action="check-all#sync">
//     <input type="checkbox" data-check-all-target="item" data-action="check-all#sync">
//   </fieldset>
//
// The "all" box is checked when every item is, indeterminate when some are, and
// clear when none are — so it reads as a summary as well as a control.
export default class extends Controller {
  static targets = ["all", "item"]

  connect() {
    this.sync()
  }

  toggle() {
    const checked = this.allTarget.checked
    this.itemTargets.forEach((item) => { item.checked = checked })
    this.sync()
  }

  sync() {
    if (!this.hasAllTarget) return

    const total = this.itemTargets.length
    const checked = this.itemTargets.filter((item) => item.checked).length

    this.allTarget.checked = total > 0 && checked === total
    this.allTarget.indeterminate = checked > 0 && checked < total
  }
}
